import { AxiosError } from 'axios';

import {
  ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS,
  ACCOUNT_SIGN_UP_USER_EMAIL_SET,
} from '@app/store/actionTypes';

export function signUpEmailResend(email: string) {
  return {
    type: ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST,
    payload: email,
  };
}

export function signUpEmailResendSuccess(payload: { message: string }) {
  return {
    type: ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS,
    payload,
  };
}

export function signUpEmailResendFailure(error: AxiosError) {
  return {
    type: ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE,
    payload: error,
    error: true,
  };
}

export function setUserEmail(email: string) {
  return {
    type: ACCOUNT_SIGN_UP_USER_EMAIL_SET,
    payload: email,
  };
}

export type AccountSignUpAction =
  | ReturnType<typeof signUpEmailResend>
  | ReturnType<typeof signUpEmailResendSuccess>
  | ReturnType<typeof signUpEmailResendFailure>
  | ReturnType<typeof setUserEmail>;
